<script lang="ts" setup>
import { mergeProps, computed } from 'vue';
import Tooltip from '@/components/Tooltip/Tooltip.vue';
import { comments } from '@/components/icons/icons';
import { HasCommentSummary } from '@/components/comments/types';

interface CommentCountProps {
  value: HasCommentSummary;
  showAlways?: boolean;
  color?: string;
}

const props = withDefaults(defineProps<CommentCountProps>(), {
  color: 'primary',
});

const count = computed(() => {
  if (!props.value.commentCount) {
    return undefined;
  } else if (props.value.commentCount < 100) {
    return props.value.commentCount?.toString();
  } else {
    return '..';
  }
});
</script>

<template>
  <div class="container text-no-wrap">
    <Tooltip v-if="value.commentCount || showAlways" position="top">
      <template #tooltip>
        <div class="tooltip-container">
          <p v-if="value.commentCount && value.commentCount > 0">
            {{ $t('LatestComment') }}:
            <span class="font-weight-semibold latestComment">
              {{ value.lastComment }}
            </span>
          </p>
          <p>
            <span>
              {{ $t('Comments') }}:
              <span class="font-weight-semibold">{{ value.commentCount }}</span>
              | {{ $t('Attachments') }}:
              <span class="font-weight-semibold">{{ value.commentAttachmentsCount }}</span>
            </span>
          </p>
        </div>
      </template>
      <template #target="{ props: targetProps }">
        <div v-bind="mergeProps(targetProps, $attrs)" class="d-flex align-center">
          <v-icon class="icon" :color="color">
            {{ comments }}
          </v-icon>
          <div class="count font-weight-semibold">{{ count }}</div>
        </div>
      </template>
    </Tooltip>
  </div>
</template>

<style lang="scss" scoped>
.container {
  display: inline-block;
}

.count {
  color: rgb(var(--v-theme-off-white));
  font-size: 10px;
  text-align: center;
  position: absolute;
  top: 0px;
  left: 4px;
  width: 14px;
  height: 18px;
  line-height: 18px;
}

.latestComment {
  text-overflow: ellipsis;
}

.tooltip-container {
  max-width: 200px;
  gap: 2px;
  line-height: 18px;
}
</style>
